import { parseNumberByPrecision } from '../../../../core/helpers/parseNumberByPrecision';
import { userInfoStore } from '../../../../store/userInfoStore';
import { sumWithDecimal } from './sumWithDecimal';

export const allChipsTotal = (betsModel, precision) => {
  return (
    betsModel &&
    betsModel?.betModel?.reduce((acc, cur) => {
      if (cur.includedBets) {
        cur.includedBets.forEach(
          // eslint-disable-next-line no-return-assign
          (item) =>
            (acc = sumWithDecimal(
              userInfoStore.precisionForBetModel,
              acc,
              parseNumberByPrecision(1, +item.amount, precision)
            ))
        );
      } else {
        // eslint-disable-next-line no-return-assign
        acc = parseNumberByPrecision(
          1,
          sumWithDecimal(userInfoStore.precisionForBetModel, +acc, +cur.bet.amount),
          precision
        );
      }
      return acc;
    }, 0)
  );
};
